import React from 'react';

import { SupplierCreateForm } from './SupplierCreateForm';

export const SupplierCreate: React.FC = () => {
  return (
    <div className="p-6 min-h-screen bg-background">
      <div className="flex flex-col gap-6">
        <h1 className="text-2xl font-semibold">Create Supplier</h1>
        <SupplierCreateForm />
      </div>
    </div>
  );
};
